import api from "../../../helpers/api";

export const getPendingArtisanProducts = (body) =>
  api.post("artisan-product-staging/search-artisan-products/", { ...body });

export const updatePendingArtisanProduct = (body) =>
  api.post("moderation-pool/moderate-artisan-products", { ...body });


export const getSinglePendingArtisanProdcut = (id) => api.get(`artisan-product-staging/get-single-product/${id}`)

export const deleteSinglePendingArtisanProdcut = (id) => api.delete(`artisan-product-staging/${id}`)

export const moderateCreateSinglePendingArtisanProduct = (id) => api.post(`artisan-product-staging/moderate-create-artisan-product`, id)
export const moderateUpdateSinglePendingArtisanProduct = (id) => api.post(`artisan-product-staging/moderate-update-artisan-product`, id)